export default "__VITE_ASSET__DV6_v74x__"